import { Component } from '@inter-ikea-core/core';

/**
 * Should be added to entities other than frames that you want the WallVisibilityValidation
 * to hinder from snapping to hidden walls.
 */
export default class WallVisibilityComponent implements Component {
  static id = 2071;
  typeId = WallVisibilityComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return true;
  }
}
